







































































































import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import SingleWord from "@/components/cards/SingleWord.vue";
import * as data from "@/model/englishjanala/englishjanala.json";
import axios from "axios";
import { Notify } from "vant";
import Questions from "@/components/cards/ConversationQuestions.vue";
import NewWord from "@/components/modals/NewWord.vue";
import Spiner from "@/components/englishjanala/Spiner.vue";
import NewQuestions from "@/components/modals/NewQuestion.vue";
import ExerciseHeader from "@/components/cards/ExerciseHeaderCard.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    SingleWord,
    NewWord,
    Spiner,
    Questions,
    NewQuestions,
    ExerciseHeader,
  },
})
export default class Home extends Vue {
  CategoryId: any;
  Category = "WordListQuestion";
  Spiner: boolean = true;
  LevelId: any;
  wordLevel: any;
  words: any = null;
  showWords: boolean = true;
  ComponentKey = 0;
  edit_title: boolean = false;
  new_exercise: any = {
    name: null,
    id: null,
    description: null,
    shortDescription: null,
    numberQuestionsSelected: null,
    questions: [],
  };
  async mounted() {
    const CatId = { category_id: this.CategoryId, level_id: this.LevelId };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/GetWordLevel",
      CatId
    );
    this.wordLevel = response.data.level;
    this.words = this.wordLevel.words;
    // this.words = this.words.isExpandable = false;
    console.log("words", this.words);
    this.Spiner = false;
    console.log("level", this.wordLevel);
  }
  showWord() {
    this.showWords = true;
  }
  showExercise() {
    this.showWords = false;
  }
  UpdateWords() {
    const data = { category_id: this.CategoryID, level: this.wordLevel };
    console.warn("update func", this.wordLevel);
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/UpdateWordLevel",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Word Level is not Updated" });
      });
    Notify({ type: "success", message: "Word Level Updated" });
  }
  created() {
    this.CategoryId = this.$route.params.CategoryId;
    this.LevelId = this.$route.params.LevelId;
  }
  get CategoryID() {
    this.CategoryId = this.$route.params.CategoryId;
    return this.$route.params.CategoryId;
  }
  get WordLevel() {
    return this.$route.params.LevelId;
  }

  get SingleLevelWords() {
    return this.getWords[0].wordLevels.filter((item) => {
      return item.id == this.LevelId;
    });
  }

  get getWords() {
    return data.wordCategories.filter((item) => {
      return item.id == this.CategoryId;
    });
  }
  get RouteParam() {
    return this.$route.params;
  }
  getImgUrl(item: any) {
    return item.imageUrl;
  }
  NewQuestion(question: any) {
    this.ComponentKey++;
    for (let i = 0; i < 4; i++) {
      if (question.answerIndices[i] == true) {
        question.answerIndices[i] = 1;
      } else question.answerIndices[i] = 0;
    }
    if (typeof this.wordLevel.exercise == "undefined") {
      this.CreateExercise();
    }
    if (question.questionType == "TRANSLATE_REARRANGE")
      question.reorderAnswerList = question.reorderAnswerList.split(" ");

    this.wordLevel.exercise.questions.push({
      reorderShuffleList: [],
      id: "",
      imageUrl: question.imageUrl,
      questionTitle: question.questionTitle,
      questionType: question.questionType,
      reorderAnswerList: question.reorderAnswerList,
      answerId: question.answerId,
      answerOptions: question.answerOptions,
      answerIndices: question.answerIndices,
    });

    Notify({ type: "success", message: "Question added" });
    // chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    question.questionTitle = "";
    question.imageUrl = "";
    (question.questionType = ""), (question.answerOptions = ["", "", "", ""]);
    question.answerId = 0;
    question.answerIndices = [0, 0, 0, 0];
    question.reorderAnswerList = [];

    window.scrollTo(0, document.body.scrollHeight);
    this.UpdateWords();
  }

  CreateExercise() {
    this.showWords = true;
    this.showWords = false;
    Vue.set(this.wordLevel, "exercise", this.new_exercise);
  }
}
